var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.25,23.999 C23.05,23.999 22.861,23.921 22.72,23.779 L12,13.06 L1.28,23.779 C1.138,23.921 0.95,23.999 0.75,23.999 C0.55,23.999 0.361,23.921 0.22,23.779 C-0.072,23.487 -0.072,23.011 0.22,22.718 L10.94,11.998 L0.22,1.279 C0.078,1.138 0,0.949 0,0.749 C0,0.549 0.078,0.36 0.22,0.219 C0.361,0.077 0.55,-0.001 0.75,-0.001 C0.95,-0.001 1.139,0.077 1.28,0.219 L12,10.938 L22.72,0.218 C22.862,0.076 23.05,-0.002 23.25,-0.002 C23.45,-0.002 23.639,0.076 23.78,0.218 C23.922,0.36 24,0.549 24,0.749 C24,0.949 23.922,1.138 23.78,1.279 L13.06,11.999 L23.78,22.719 C24.072,23.011 24.072,23.487 23.78,23.78 C23.639,23.921 23.45,23.999 23.25,23.999 Z"}));
}

Close.defaultProps = {"viewBox":"0 0 24 24","version":"1.1"};

module.exports = Close;

Close.default = Close;
